import { PageKind } from './overview_page'
import {
  renderArticlesFilter,
  RenderFilterBlock,
} from './components/filterBlock/render_filter_block'
import {
  renderArticleBlocks,
  renderCasesBlocks,
  renderJobBlocks,
  RenderOverviewBlocks,
  // renderVacaturesBlocks
} from './components/overviewItemsBlock/overview_items_block'

export type OverviewStyle = Partial<{
  main: string
  renderFilterBlock: RenderFilterBlock
  renderOverviewBlocks: RenderOverviewBlocks
}>

export const ArticleOverviewStyle: OverviewStyle = {
  main: 'page--articles main--resource-overview',
  renderFilterBlock: renderArticlesFilter,
  renderOverviewBlocks: renderArticleBlocks
}

export const getStyle = (page: PageKind): OverviewStyle => {
  let articleOverviewStyle = ArticleOverviewStyle
  if (page == 'resource-overview' || page == 'search-overview' || page == 'news-overview' || page == 'team-overview' || page == 'testimonial-overview') {
    return articleOverviewStyle
  }
  if (page == 'vacancy-overview') {
    return {...articleOverviewStyle, renderOverviewBlocks: renderJobBlocks}
  }

}
